/* eslint-disable @typescript-eslint/no-unused-vars */

const FilterChild = ({
  property,
  label,
  placeholder,
  value,
  // width,
  type,
  first,
  last,
  disabled,
  children,
  zIndex,
  showSearchAdornment,
  inFocus,
  className,
}: {
  property: string;
  label: string;
  placeholder: string;
  value: string;
  // width: number;
  type: "popup" | "filter";
  first?: boolean;
  last?: boolean;
  disabled?: boolean;
  children: React.ReactNode | React.ReactElement;
  zIndex?: number;
  showSearchAdornment?: boolean;
  inFocus?: boolean;
  className?: string;
}) => {
  return children as any;
};

export default FilterChild;
